import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { components } from "react-select";
import { Divider } from "../Divider";
import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  chipContainer: {
    maxHeight: theme.spacing(12.5),
    padding: theme.spacing(2),
    ...theme.scrollbars?.main,
    "&.prmbl-autocomplete__value-container--is-multi": {
      overflow: "auto"
    }
  },
  divider: {
    background: theme.palette.grey["500"],
    margin: 0 + "!important"
  }
}));
const MenuList = props => {
  const classes = useStyles(props);
  const data = props.getValue();
  const removeItem = itemName => {
    const newList = data.filter(item => item.value !== itemName);
    props.setValue(newList, "deselect-option");
  };
  const chipProps = {
    components: {
      Container: components.MultiValueContainer,
      Label: components.MultiValueLabel,
      Remove: components.MultiValueRemove
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.isMulti && data.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(components.ValueContainer, _extends({
    className: classes.chipContainer
  }, props, {
    isDisabled: false
  }), data.map((itemSelected, index) => /*#__PURE__*/React.createElement(components.MultiValue, _extends({
    key: itemSelected.value,
    index: index
  }, props, chipProps, {
    data: itemSelected,
    removeProps: {
      onClick: () => removeItem(itemSelected.value),
      onTouchEnd: () => undefined,
      onMouseDown: () => undefined
    },
    cropWithEllipsis: false,
    isFocused: false,
    isDisabled: false
  }), itemSelected.label))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  })), /*#__PURE__*/React.createElement(components.MenuList, props, props.children));
};
export default MenuList;